<ion-content class="account-history-screen tw-pt-[16px] tw-pb-[16px] tw-pr-[30px] tw-pl-[30px]" data-cy="acc-history-screen">

  <!-- Heading -->
  <div class="heading-section tw-relative">
    <ion-icon
      name="arrow-back-outline"
      data-cy="acc-history-arrow"
      (click)="close()"
      class="soft-back tw-text-[20px] tw-text-white tw-p-[5px] tw-absolute"
    />
    <ion-title class="tw-text-center"
      class="
      tw-text-center
      tw-text-[20px]
      tw-font-bold
    "
      data-cy="acc-history-title"
    >
      Account History
    </ion-title>
    <span (click)="close()"
      class="
      close
      tw-absolute
      tw-capitalize
      tw-text-[16px]
    "
      data-cy="acc-history-close"
    >
      Close
    </span>
  </div>

  <!-- History -->
  <div class="my-history-section">

    <div class="statements-content">
      <!-- Statements -->
      <div
        (click)="selectHistory('statements')"
        class="statements history-row"
        data-name="statements"
        data-cy="acc-history-statements"
      >
        <img
          src="/assets/images/account_settings/account-statements-light.png"
          class="l-mode tw-inline tw-mr-[19px]"
          data-cy="his-statement-iconLight"
        >
        <img
          src="/assets/images/account_settings/account-statements-dark.png"
          class="d-mode tw-inline tw-mr-[19px]"
          data-cy="his-statement-iconDark"
        >
        <span slot="start" class="tw-text-[16px]" data-cy="his-statement-txt">Statements</span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right" data-cy="his-statement-close"></ion-icon>
        <ion-icon name="chevron-down-outline" class="open-chev chev-right" data-cy="his-statement-open"></ion-icon>
      </div>

      <!-- Bet Summary-->
      <div
        (click)="selectHistory('betSummary')"
        class="betSummary history-row"
        data-name="betSummary"
        data-cy="acc-history-bet-sum"
      >
        <img
          src="/assets/images/account_settings/bet-summary-light.svg"
          class="l-mode tw-inline tw-mr-[19px]"
          data-cy="his-betSum-iconLight"
        >
        <img
          src="/assets/images/account_settings/bet-summary-dark.svg"
          class="d-mode tw-inline tw-mr-[19px]"
          data-cy="his-betSum-iconDark"
        >
        <span slot="start" class="tw-text-[16px]" data-cy="his-betSum-txt">Bet Summary</span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right" data-cy="his-betSum-close"></ion-icon>
        <ion-icon name="chevron-down-outline" class="open-chev chev-right" data-cy="his-betSum-open"></ion-icon>
      </div>

      <!-- Overview -->
      <div
        (click)="selectHistory('overview')"
        class="overview history-row"
        data-name="overview"
        data-cy="acc-history-overview"
      >
        <img
          src="/assets/images/account_settings/overview-light.png"
          class="l-mode tw-inline tw-mr-[19px]"
          data-cy="his-overview-iconLight"
        >
        <img
          src="/assets/images/account_settings/overview-dark.png"
          class="d-mode tw-inline tw-mr-[19px]"
          data-cy="his-overview-iconDark"
        >
        <span slot="start" class="tw-text-[16px]" data-cy="his-overview-txt">Overview</span>
        <ion-icon name="chevron-forward-outline" class="close-chev active-chev chev-right" data-cy="his-overview-close"></ion-icon>
        <ion-icon name="chevron-down-outline" class="open-chev chev-right" data-cy="his-overview-open"></ion-icon>
      </div>
    </div>

    <!-- Dynamic Content -->
    <div class="content">
      <!-- Statements -->
      <div class="statements card-content card-hide" data-name="statements">
        <feature-ion-statements *ngIf="controller.statements"></feature-ion-statements>
      </div>
    </div>

  </div>

</ion-content>
